import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
// @ts-expect-error untyped import
import { getInAppReviewLink } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const I18N_BASE = 'ecosystem-marketplace-solutions-ui.profile.reviews';
const WriteReviewButton = ({
  hasEditableReview,
  isPreview,
  isPublicApp,
  profileListing,
  setWizardOpen,
  size = 'default',
  unreviewableReason,
  reviewButtonRef
}) => {
  const {
    slug
  } = profileListing;
  const isReviewable = isPublicApp || !unreviewableReason || unreviewableReason !== 'ReviewError.EDIT_PENDING' && hasEditableReview;
  let buttonProps = {};
  if (!isPreview) {
    if (isPublicApp) {
      buttonProps = {
        href: getInAppReviewLink(slug)
      };
    } else {
      buttonProps = {
        onClick: () => setWizardOpen(true)
      };
    }
  }
  return /*#__PURE__*/_jsx("div", {
    ref: reviewButtonRef,
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `marketplace-ui-reviews.error.${unreviewableReason}`
      }),
      disabled: isReviewable,
      children: /*#__PURE__*/_jsx(Button, Object.assign({
        disabled: !isReviewable,
        use: hasEditableReview ? 'tertiary-light' : 'tertiary',
        size: size,
        tabIndex: 0
      }, buttonProps, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_BASE}.write.${hasEditableReview ? 'edit' : 'button'}`
        })
      }))
    })
  });
};
export default WriteReviewButton;